import script from "./lanmuindex.vue?vue&type=script&setup=true&lang=js"
export * from "./lanmuindex.vue?vue&type=script&setup=true&lang=js"

import "./lanmuindex.vue?vue&type=style&index=0&id=829ba59e&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\kepukeyanchengguozhanshi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-829ba59e"]])

export default __exports__